<template>
    <div>
        <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Task Title</th>
                <th>Open Date</th>
                <th @click="sort('due_date')">
                  Required Date
                  <span style="cursor: pointer">
                    <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                        fill="#707070" />
                      <path
                        d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                        fill="#707070" />
                    </svg>
                  </span>
                </th>
                <th>Approved Date</th>
                <th>Assigned To</th>
                <th>Status</th>
                <th>Actions</th>
                <!-- <th>Action</th> -->
              </tr>
            </thead>
            <tbody id="table_body">
              <tr  v-if="isLoader" id="table_row" >
                <td colspan="16">
                  <b-skeleton-wrapper >
                      <b-skeleton height="40px" ></b-skeleton>   
                      <b-skeleton height="40px"></b-skeleton>  
                      <b-skeleton height="40px"></b-skeleton>                                     
                  </b-skeleton-wrapper> 
                </td>
              </tr>
              <tr  v-show="!isLoader" v-for="task in tasks" :key="task.id">
                <td v-if="task.organizations">
                  {{ task.organizations}}
                </td>
                <td v-else class="text-center">
                   -----
                </td>
                <td v-if="task.title">
                  {{ task.title}}
                </td>
                <td v-else>
                  -----
                </td>
                <td>
                  {{ task.created_at}}
                </td>
                <td  v-if="task.due_date != ''">
                  {{ task.due_date }}
                </td>
                <td v-else class="text-center">
                   -----
                </td>
                <td  v-if="task.due_date != ''">
                  {{ task.due_date }}
                </td>
                 <td v-else class="text-center">
                   -----
                </td>
                <td v-if="task.assigned_to.hasOwnProperty('name')">
                  {{ task.assigned_to.name}} 
                </td>
                <td v-else class="text-center">
                   -----
                </td>
                <td>
                  {{ getStatusName(task.status)}}
                </td>
                <td class="text-center">
                  <a  class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                    <span class="fas fa-ellipsis-v"></span>
                  </a>
                  <ul class="dropdown-menu action-list">
                     <!-- <li><router-link :to="'/development-tasks/schedular'" class="dropdown-item"> View</router-link></li> -->
                    <li><a class="dropdown-item" :data-id="task.id" @click="quickView"> View</a></li>
                    <li><a class="dropdown-item" :data-id="task.id" @click="edit"> Edit</a></li>
                    <li><a class="dropdown-item" v-if="task.status == 0" @click="assignTo(task)">Assign To</a></li>
                    <li><a class="dropdown-item" v-if="task.status == 1" :data-id="task.id" @click="startWorking">Start Working</a></li>
                    <li><a class="dropdown-item" v-if="task.status == 2"  @click="updateStatus(task.id,3)">On Hold</a></li>
                    <li><a class="dropdown-item" v-if="task.status == 2"  @click="updateStatus(task.id,4)">Completed</a></li>
                    <li><a class="dropdown-item" v-if="task.status == 3"  @click="updateStatus(task.id,2,'resume')">Resume</a></li>
                    <li><a class="dropdown-item" v-if="task.status != 4 && task.status != 0" @click="extendDueDate(task)"> Extend Due-Date</a></li>
                  </ul>
                </td>
                <!-- <td>
                </td> -->
              </tr>
              <tr  v-if="tasks.length < 1 && !isLoader" >
                <td colspan="8" class="text-center"> No Record Found
                  </td>
              </tr>
            </tbody>
        </table>
        <div v-if="!isLoader">
      <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
        :first-button-text="''" :last-button-text="''" :first-last-button="true"
        :container-class="'pagination pagination-sm float-right mb-2 mr-4 mb-0'" :page-class="'page-item'"
        :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
        :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
        <span class=" float-right mb-2 mr-4 mb-0 display-rows" style="color:#48a6a6;">Display Rows: <b>{{totalRows}}</b></span>
        <span class=" float-right mb-2 mr-4 mb-0 display-rows" style="color:#48a6a6;">Total Tasks: <b>{{totalRecords}}</b></span>
    </div>
         <!-- <h5 style="text-align: center; margin-top:2rem;" v-if="tasks.length < 1 && !isLoader">
          No data found.
        </h5> -->
    </div>
</template>
<script>

import taskForm from "./form.vue";
import quickView from "./quickView.vue";
import moment from "moment";
  Vue.filter("formatDate", function (value) {
    if ( value != null) {
      return moment(String(value)).format("DD MMM, Y");
    }
  });
export default {
  props:['orgList','tasks','setSkeletonLoader','totalRows','totalPages','developers','selTab','departments'],
  data: function () {
      return {
        isLoader: false,
        // search: '',
        // statusNames: {
        //   0: 'Pending',
        //   1: 'Assigned',
        //   2: 'In Progress',
        //   3: 'On Hold',
        //   4: 'Delivered',
        // },
        sortingBy: {
          created_at: true,
          due_date: true,
          assigned_to: true,
        },
      };
    },
    computed:{
       currentPage:{
        get: function () {
          this.selectedPage = this.$store.getters["tasks/currentPage"];
          return this.selectedPage;
        },
        set: function () { },
      },
      statusNames:function(){
        return this.$store.getters['tasks/statusNames'];
      },
      search:function(){
        return this.$store.getters['tasks/search'];
      },
      showskLoader: {
        get:function(){
          return this.setSkeletonLoader
        },
        set: function (val) {
          this.isLoader = val;
          return val;
         },
      },
      totalRecords: function () {
        return this.$store.getters["tasks/totalRecords"];
      },
      
    },
    watch:{
      showskLoader: function (val) {
        this.isLoader = val;
        return val;
      },

     } ,
    mounted: function () {
      this.showskLoader = this.setSkeletonLoader;
    },
    methods:{
        setPage(page) {
          this.$emit("setPage", page);
        },
        edit(event){
          this.$store.dispatch("tasks/edit",[event.target.dataset.id]).then((response)=>{
            this.$store.dispatch("modal/taskModal", {
              action: "edit",
              title: "Edit Task",
              formData: {
                task: response,
                developers: this.developers,
              },
               component: taskForm 
             });
          });
        },
        assignTo(task){
          this.$store.dispatch("modal/taskModal", {
            action: "assign_to",
            title: "Update Status",
            formData: {
              task: task,
              developers: this.developers,
            },
            component: taskForm,
          });    
        },
        extendDueDate(task){
          let task_info = event.target.dataset;
          this.$store.dispatch("modal/taskModal", {
            action: "extend_due_date",
            title: "Extend Due-Date",
            formData: {
              task: task,
            },
            component: taskForm,
          });         
        },
        startWorking(event){
          let task_info = event.target.dataset;
          this.$store.dispatch("message/update", {
            title: "Update Status",
            body: "All the active tasks will be de-activated",
            class: "warning",
            confirm: true,
          });

          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.$store.dispatch("message/close");
            this.updateStatus(task_info.id, 2);      
            
          });
        },
        updateStatus(id, status, status_name=''){
          let formData ={};
          formData.id = id;
          formData.status = status;
          this.$store.dispatch("tasks/updateStatus",[formData])
            .then((response) => {
              this.$parent.getRecords();
              let msg = '';
              if(status_name == 'resume'){
                msg = "has been resumed";                     
              }else{
                msg = "status has been updated to "+ this.getStatusName(status);
              }                           
              this.$toast.success("Task "+msg+" successfully.");
            });
        },
        quickView(event){
          this.$store.dispatch("tasks/view",[event.target.dataset.id]).then((response)=>{
            this.$store.dispatch("modal/taskQuickView", {
              title: "Task Details",
              formData: {
                task: response,
                developers: this.developers,
              },
              component: quickView,
            });  
          });
          
        },
        getStatusName(status) {
          return this.statusNames[status] || 'Pending';
        },
        sort(column) {
          let direction = this.sortingBy[column];
          localStorage.setItem('direction', direction); 
          localStorage.setItem('column', column);
            
          if (localStorage.getItem('setPageDirection') =='false' && direction == true) {
            localStorage.setItem('direction', false);
            direction = false;
            this.sortingBy[column] = false;
          }

          this.$emit('update-sortingby-variable', {column: column, direction: direction == true  ? "asc" : "desc"});
          this.$parent.getRecords();
          this.sortingBy[column] = !this.sortingBy[column];
          localStorage.setItem('setPageDirection', this.sortingBy[column]);
        },
        getRecords() {
          this.$parent.getRecords();
        }
      },
      
}
</script>
<style scoped>
table thead th tr th{
  text-align: left !important;
}
</style>
